import React from 'react';
import { Reveal } from '../ui/Reveal';
const BLOQUES = [{
  emoji: '🌅',
  titulo: 'Un ritmo que honra mente, cuerpo y alma',
  texto: 'Mañanas desde la calma y la presencia, tardes de experiencia y conexión profunda, noches de integración y gratitud. Este retiro no está construido desde un temario "rellenador".'
}, {
  emoji: '🤍',
  titulo: 'Cada práctica tiene su propósito',
  texto: 'Cada momento fue diseñado desde lo que queremos que sientas y vivas. Cada actividad tiene un hilo conductor: que lo vivido te transforme, no solo te relaje.'
}];
export function Ritmo() {
  return <section className="w-full px-5 py-24 sm:px-8 sm:py-32" data-id="element-243" data-mp="1i5zkacwb9b4t">
      <div className="mx-auto max-w-5xl text-center" data-id="element-244" data-mp="1d6d1zp1ml4p5">
        <Reveal data-id="element-245" data-mp="1d7xyhk7i2xpn">
          <span className="text-xs font-medium uppercase tracking-[0.28em]" style={{
          color: 'var(--satinsheengold)'
        }} data-id="element-246" data-mp="1d4a3shqbk59c">
            Intención y ritmo
          </span>
          <h2 className="mt-4 font-heading text-3xl font-light leading-tight sm:text-4xl" style={{
          color: 'var(--ink)'
        }} data-id="element-247" data-mp="7n2rtq6i01et">
            Un viaje diseñado desde adentro
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-248" data-mp="3tspxypk5s16n">
          {BLOQUES.map((b, i) => <Reveal key={b.titulo} delay={i * 0.1} data-id="element-249" data-mp="2mf2d8xx3smp" data-mpi={i}>
              <article className="h-full rounded-3xl border p-8 text-left" style={{
            borderColor: 'rgba(24,161,184,0.2)',
            backgroundColor: 'rgba(24,161,184,0.05)'
          }} data-id="element-250" data-mp="qdu8zdwq8w3r">
                <span className="text-4xl" data-id="element-251" data-mp="lf0rlaebkkyb">{b.emoji}</span>
                <h3 className="mt-4 font-heading text-xl font-normal" style={{
              color: 'var(--ink)'
            }} data-id="element-252" data-mp="ldfzrsje3g45">
                  {b.titulo}
                </h3>
                <p className="mt-3 text-sm leading-relaxed" style={{
              color: 'rgba(42,36,32,0.72)'
            }} data-id="element-253" data-mp="1cm9euncos6x0">
                  {b.texto}
                </p>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}